import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import Head from 'next/head';

import type { NextPage } from 'next';
import { Structure } from '@/types/app';

import AssetListTable from '@/components/list/AssetListTable';
import AssetTypeHero from '@/components/list/AssetTypeHero';
import MarginContainer from '@/components/global/MarginContainer';
import ClosingOffer from '@/components/homepage/ClosingOffer';
import Footer from '@/components/global/Footer';

/**
 * This is to handle translation server-side.
 */
export async function getStaticProps({ locale }) {
  return {
    props: {
      ...(await serverSideTranslations(locale, [
        'common',
        'detail',
        'homepage',
        'errors',
        'footer',
      ])),
    },
  };
}

const AllStocks: NextPage = () => {
  const { t } = useTranslation(['common']);

  return (
    <div className="flex w-full flex-col items-center">
      <Head>
        <title>{t('stocks')} - Structure</title>
      </Head>

      <MarginContainer padded>
        <AssetTypeHero type={Structure.PagedResponseAssetInfoType.STOCK} />
        <div className="mt-10 mobile:mt-12 tablet:mt-16">
          <AssetListTable type={Structure.PagedResponseAssetInfoType.STOCK} />
        </div>
        <ClosingOffer />
      </MarginContainer>
      <Footer />
    </div>
  );
};

export default AllStocks;
